module.exports = __webpack_public_path__ + "img/ic-google.52fbd5b0.svg";